module.exports = {"title":"Лекции по ИИ от Ворониной И.Е.","body":"<h3>Что это?</h3>\n<p>Лекции Ворониной по ИИ.</p>\n<h3>Achtung!</h3>\n<p>Материалы на этом сайтике не претендуют на абсолютную достоверность и полноту… И вообще, я мимо проходил… :D</p>\n<h3>Justice demands contribution!</h3>\n<p>Нашли ошибку? Чего-то не хватает? <s>В интернете кто-то не прав?</s><br>\nОтправляйте pull request’ы сюда: <a href=\"https://github.com/voronina-ai/lectures-website\">https://github.com/voronina-ai/lectures-website</a></p>\n<hr/>\n<p>Сайт работает на <a href=\"https://github.com/gatsbyjs/gatsby\">Gatsby</a></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./index.md
// module id = 490
// module chunks = 0